import { Box, Link, Typography } from '@mui/material';
import PricebookInfoPopup from './PricebookInfoPopup';
import { Price } from '../models/PricebookData';
import {
  getPricebookListPriceLabel,
  getPricebookPopupBody,
  getPricebookPopupTitle,
} from '../helpers/pricebookUtils';

interface PricebookRowLabelProps {
  name: string;
  price?: Price;
  shortDescription?: string;
  metadata?: { subHeader?: string; nonProfit?: boolean } | null;
  onNameClick?: () => void;
  truncate?: boolean;
}

const PricebookRowLabel: React.FC<PricebookRowLabelProps> = ({
  name,
  price,
  shortDescription,
  metadata,
  onNameClick,
  truncate,
}) => {
  const priceInDollars = price ? price.price / 100 : 0;
  const [priceStr, intervalStr] = price ? getPricebookListPriceLabel(price).split(' | ') : [];

  const infoIcon = shortDescription && (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0, ml: '4px' }}>
      <PricebookInfoPopup
        title={getPricebookPopupTitle(metadata, priceInDollars) || undefined}
        body={getPricebookPopupBody(shortDescription)}
        iconVariant='custom'
        iconSize={20}
        ariaLabel={`More about ${name}`}
      />
    </Box>
  );

  const nameTypography = onNameClick ? (
    <Link
      component='button'
      variant='p16SemiBold'
      color='secondary.dark'
      underline='none'
      onClick={onNameClick}
      noWrap={truncate}
      sx={{ 'minWidth': 0, 'textAlign': 'left', '&:hover': { opacity: 0.7 } }}>
      {name}
    </Link>
  ) : (
    <Typography
      component='span'
      variant='p16SemiBold'
      color='secondary.dark'
      noWrap={truncate}
      sx={{ minWidth: 0 }}>
      {name}
    </Typography>
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: truncate ? 0 : undefined }}>
      <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
        {nameTypography}
        {infoIcon}
      </Box>
      {price && (
        <Typography variant='p12' color='secondary.main' noWrap={truncate} sx={{ mt: '4px' }}>
          {priceStr}
          <Typography component='span' variant='p12' sx={{ mx: '5px' }}>
            |
          </Typography>
          {intervalStr}
        </Typography>
      )}
    </Box>
  );
};

export default PricebookRowLabel;
